import {GetServerSidePropsContext} from "next/types";
import {getServerSideProps as getLocaleProps} from "@/base/utils/localalization";
import MetaBlock from "@/base/components/MetaBlock";
import React from "react";
import SourcePage from '@/base/pages/support/create';
import WrapSupport from "@/components/main/WrapSupport";

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
	return {
		...(await getLocaleProps(ctx, ['base-common', 'base-support', 'meta'])),
	};
}

export default function Page(props: any) {
	return <>
		<MetaBlock
			// title={t => t('base-support:meta.index.title')}
			// description={t => t('base-support:meta.index.description')}
			title={(t) => t('meta:supportcreate-title')}
			description={(t) => t('meta:supportcreate-title')}
		/>
		<WrapSupport>
			<SourcePage {...props} />
		</WrapSupport>
	</>
};

Page.getLayout = SourcePage.getLayout;